module.exports = __webpack_public_path__ + "674a224f7b396571a3e68f49be0d86f1.woff";